import { render, staticRenderFns } from "./heroSix.vue?vue&type=template&id=58a5667b&"
import script from "./heroSix.vue?vue&type=script&lang=js&"
export * from "./heroSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports